const enabled = () => typeof process !== "undefined" && process.env.WC_DEBUG === "1";
function clip(v) {
    if (typeof v === "string")
        return v.length > 40 ? `${v.slice(0, 12)}…(${v.length})` : v;
    if (Array.isArray(v))
        return v.map(clip);
    if (v && typeof v === "object") {
        const out = {};
        for (const [k, val] of Object.entries(v))
            out[k] = clip(val);
        return out;
    }
    return v;
}
export function log(side, label, extra) {
    if (!enabled())
        return;
    const t = new Date().toISOString().slice(11, 23);
    const rest = extra === undefined ? "" : ` ${JSON.stringify(clip(extra))}`;
    console.error(`${t} ${side} ${label}${rest}`);
}
//# sourceMappingURL=debug.js.map